import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'AdminEmployeeList',
  description: 'A list of all employees',
  categories: ['admin', 'list'],
  // inline: true,
  props: t.object({
  }),
   examples: {
     basic: {
       props: {
       },
       description: ''
     }
   },
  todo: [ ],
})
